/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2023 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\mixins\checkFieldHide.js                                         *
 * Project: frontend                                                           *
 * Created Date: Wednesday, November 8th 2023, 11:47:14 am                     *
 * Author: Prudhvi Teja <prudhvi@codestax.ai>                                  *
 * -----                                                                       *
 * Last Modified: March 7th 2024, 5:51:21 pm                                   *
 * Modified By: Sankarra Narayanan                                             *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

export const commonFunction = {
    inheritAttrs: false,
    methods: {
        checkColumnAccess(accessList, workFlowId, currentStatus, roleGroup) {
            let bool = false;
            if (accessList && accessList['ALL']) {
                if (accessList['ALL']['ALL']) {
                    if (accessList['ALL']['ALL'].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList['ALL']['ALL'].includes(roleGroup)) {
                        bool = true;
                    }
                }
                else if (accessList['ALL'][currentStatus]) {
                    if (accessList['ALL'][currentStatus].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList['ALL'][currentStatus].includes(roleGroup)) {
                        bool = true;
                    }
                }
                else if (accessList['ALL']['defaultStage']) {
                    if (accessList['ALL']['defaultStage'].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList['ALL']['defaultStage'].includes(roleGroup)) {
                        bool = true;
                    }
                }
            }
            else if (accessList && accessList[workFlowId]) {
                if (accessList[workFlowId]['ALL']) {
                    if (accessList[workFlowId]['ALL'].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList[workFlowId]['ALL'].includes(roleGroup)) {
                        bool = true;
                    }
                }
                else if (accessList[workFlowId][currentStatus]) {
                    if (accessList[workFlowId][currentStatus].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList[workFlowId][currentStatus].includes(roleGroup)) {
                        bool = true;
                    }
                }
                else if (accessList[workFlowId]['defaultStage']) {
                    if (accessList[workFlowId]['defaultStage'].includes('ALL')) {
                        bool = true;
                    }
                    else if (accessList[workFlowId]['defaultStage'].includes(roleGroup)) {
                        bool = true;
                    }
                }
            }
            return bool;
        },
        allKeysEmpty(obj) {
            for (let key of Object.keys(obj)) {
                if (key in obj && obj[key] !== '') {
                    return false;
                }
            }
            return true;
        },
        removeEmptyObjects(list) {
            let result = [];
            for(let data of list){
                let res = this.allKeysEmpty(data);
                if(!res) result.push(data);
            }
            return result;
        },
        checkColumnRange(range, columnValue, value, columnName){
            let numberRangeErrorList = [];
            if(range.min !== undefined && range.max){
                const min = range.min;
                const max = range.max;
                if(!(columnValue>=min && columnValue<=max)){
                  const validationMessage = `value must be in between ${min} and ${max}.`;
                  numberRangeErrorList.push({
                          'columnName': columnName + " " + validationMessage,
                          'row': Number(value) + 1

                  });
                } 
              }
              if(range.min !== undefined && range.max === undefined){
                const min = range.min;
                if(!(columnValue>=min)){
                  const validationMessage = `value must be greater than ${min}.`;
                  numberRangeErrorList.push({
                          'columnName': columnName + " " + validationMessage,
                          'row': Number(value) + 1

                  });
                }
              }
              if(range.min === undefined && range.max){
                const max = range.max;
                if(!(columnValue<=max)){
                  const validationMessage = `value must be lesser than ${max}.`;
                  numberRangeErrorList.push({
                          'columnName': columnName + " " + validationMessage,
                          'row': Number(value) + 1

                  });
                }
              }
              return numberRangeErrorList;
        },
    }
};
